import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom';

import Header from "./components/Header";
import Home from "./pages/Home";

import "./assets/css/fonts.css";
import "./assets/css/public.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import WidgetPreview from "./pages/WidgetPreview";

function App() {
    return (
        <div dir="rtl">
            <Header/>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/widget-preview" element={<WidgetPreview/>}/>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
